(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceQuestionDeleteController',RaceQuestionDeleteController);

    RaceQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'RaceQuestion'];

    function RaceQuestionDeleteController($uibModalInstance, entity, RaceQuestion) {
        var vm = this;

        vm.raceQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RaceQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
